function canUseSessionStorage() {
  try {
    return typeof window !== 'undefined' && 'sessionStorage' in window
  } catch {
    return false
  }
}

export function safeSetSessionStorageItem(key: string, value: string) {
  if (!canUseSessionStorage()) return

  try {
    window.sessionStorage.setItem(key, value)
  } catch {
    // Ignore storage errors (private mode, blocked storage, etc.)
  }
}

export function safeGetSessionStorageItem(key: string) {
  if (!canUseSessionStorage()) return

  try {
    return window.sessionStorage.getItem(key)
  } catch {
    return null
  }
}

export function safeRemoveSessionStorageItem(key: string) {
  if (!canUseSessionStorage()) return

  try {
    window.sessionStorage.removeItem(key)
  } catch {
    // Ignore storage errors (private mode, blocked storage, etc.)
  }
}
